module.exports = __webpack_public_path__ + "static/media/arnie26.6fd8b2dc.jpg";